
import WDOptionList from './wd-option-list';

export default class WDDropdown extends WDOptionList
{
	constructor(cfg)
	{
		super(cfg);
		
		this.classList.add('dropdown-menu');
		this.setAttribute('role', 'menu');
		this.on('item:selected',() => this.hide() );
		
		return this;
	};

	createItem()
	{
		const item = super.createItem();
		item.classList.add('dropdown-item');

		return item;
	};

	addDivider()
	{
		const d = wdc('<div class="dropdown-divider"/>');
		this.append(d);
		return d;
	};

	addPrefix(obj)
	{
		const prefix = wdc('<div class="dropdown-item"/>');
		prefix.on('click', (evt) => evt.preventDefault());

		this.prepend(prefix);

		if (obj) prefix.append(obj);

		return prefix;
	};

	set dropup(val)
	{
		if (val == true) this.parentElement.classList.add('dropup');
		else this.parentElement.classList.remove('dropup');
	};

	toggle()
	{
		const instance = bootstrap.Dropdown.getOrCreateInstance(this.previousElementSibling);
		if (instance) instance.toggle();
	};

	show()
	{
		const instance = bootstrap.Dropdown.getOrCreateInstance(this.previousElementSibling);
		if (instance) instance.show();
	};

	hide()
	{
		const instance = bootstrap.Dropdown.getOrCreateInstance(this.previousElementSibling);
		if (instance) instance.hide();
	};

};

customElements.define('wd-dropdown', WDDropdown);

